module.exports = {
    API_URL: process.env.REACT_APP_API_URL,
    PORT: process.env.PORT,
    LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
    LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL,
    FRONT_URL: process.env.REACT_APP_FRONT_URL
  };